/**
 * Utility for getting user location information
 */

interface LocationInfo {
  country?: string;
  region?: string;
  timezone?: string;
  ip?: string;
}

/**
 * Get user location information based on IP address
 * Uses ipinfo.io free tier service (limited to 50,000 requests per month)
 */
export const getUserLocationInfo = async (): Promise<LocationInfo> => {
  try {
    // Use environment variable for token or fallback to a public endpoint without token
    const token = process.env.REACT_APP_IPINFO_TOKEN || '';
    const tokenParam = token ? `?token=${token}` : '';
    const response = await fetch(`https://ipinfo.io/json${tokenParam}`);
    
    if (!response.ok) {
      throw new Error('Failed to fetch location info');
    }
    const data = await response.json();
    
    return {
      country: data.country,
      region: data.region,
      timezone: data.timezone,
      ip: data.ip
    };
  } catch (error) {
    console.error('Error getting location info:', error);
    // Return empty object on error, don't block subscription
    return {};
  }
};

/**
 * Get basic browser and device information
 */
export const getBrowserInfo = (): Record<string, string> => {
  return {
    userAgent: navigator.userAgent,
    language: navigator.language,
    platform: navigator.platform,
    vendor: navigator.vendor,
    screenWidth: window.screen.width.toString(),
    screenHeight: window.screen.height.toString(),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  };
};